// file for handling the top filters.
//Import Libraries
import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useState } from "react";
import { withRouter } from "react-router";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { config } from "../../../../config/config";
import { updateAlert, updateSourceInputs } from "../../../../redux/actions";
import { InputLabel } from "@material-ui/core";
import "../localreporting.scss";
import Loader from "../../../../components/Loader/Loader";
import FileUpload from "../../../../components/FileUpload/FileUpload";
import GlobalDropZone from "../../../../components/FileUpload/GlobalDropZone";
import { useUserAuthentication } from "../../../../utils/utils";
import Popover from "@mui/material/Popover";
import { useHistory } from "react-router-dom";

let api = config.api.api_url;

function MetaSearchFilter(props) {
  let {
    user,
    source_data,
    updateSourceInputs,
    isFileUploading,
    loading,
    setMappedData,
    updateAlert,
    setMappedDataCreateNew,
    isPlaceholderFetching,
  } = props;
  const [expand, setExpand] = useState(false);
  const [isCountryLoading, setIsCountryLoading] = useState(false);
  // const [isMappingTypeLoading, setIsMappingTypeLoading] = useState(false);
  let history = useHistory();
  const URL = history?.location?.pathname;
  const Use_Case_Name = URL.split("/").pop();
  const { login } = useUserAuthentication();

  const is_Approver = useMemo(() => {
    const Is_Role_Approver = user?.role && user?.role?.includes("AppApprover");
    const URL = history?.location?.pathname || [];
    const result = URL.split("/").pop();
    const is_Approver_For_This_Usecase =
      user?.approval_screens && user?.approval_screens?.includes(result);
    return Is_Role_Approver && is_Approver_For_This_Usecase;
  }, [user.role, user.approval_screens]);

  // FETCH META DATA FOR SELECTED DATASET
  const handleSourceChange = async (e, selectedOption) => {
    updateSourceInputs("current_source", selectedOption.value);
    updateSourceInputs("is_initial", true);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_mapped_data_main", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("current_ssfFileId", "");
    updateSourceInputs("searchValue", "");
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("any_row_isEditing", false);

    setMappedData(selectedOption?.value || "");
  };

  return (
    <>
      {!is_Approver && (
        <div className="cnc-toggle-icon">
          <label
            onClick={() => {
              setExpand(!expand);
            }}
          >
            {!expand ? "Collapse" : "Expand"}
          </label>
          <i
            className="material-icons"
            onClick={() => {
              setExpand(!expand);
            }}
          >
            {!expand ? "keyboard_arrow_up" : "keyboard_arrow_down"}
          </i>
        </div>
      )}

      {!expand && (
        <div className="cnc-model-header-mapping">
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)", // 5 equal-width columns
              gridTemplateRows: "1fr", // 1 row
              gap: "12px", // gap between columns (and rows if any)
              padding: "2px 15px 0px 15px",
              width: "100%",
            }}
          >
            <>
              {/* DATASETS */}
              <div item xs={3} sm={3}>
                <div
                  className="mg-model-header-item"
                  style={{ height: "25px" }}
                >
                  Select Source:{" "}
                  <p
                    style={{
                      display: "inline",
                      color: "red",
                      fontSize: 16,
                    }}
                  >
                    *
                  </p>
                </div>
                <div className="" style={{ marginBottom: "15px" }}>
                  <Autocomplete
                    id="country-select"
                    disableClearable
                    size="small"
                    options={source_data?.current_mapped_source || []}
                    loading={
                      loading &&
                      (source_data.current_mapped_source ||
                        source_data.current_mapped_source.length === 0)
                    }
                    loadingText={<Loader />}
                    getOptionLabel={(option) => option.label}
                    onChange={handleSourceChange}
                    value={
                      source_data.current_source &&
                      source_data.current_source.length > 0
                        ? {
                            label: source_data.current_source,
                            value: source_data.current_source,
                          }
                        : null
                    }
                    popupIcon={
                      <span
                        className="material-icons"
                        style={{
                          fontSize: "20px",
                          color: "#555",
                        }}
                      >
                        arrow_drop_down
                      </span>
                    }
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#fff",
                        fontFamily: "Hind Siliguri",
                        borderRadius: "6px",
                        fontSize: "13px",
                        fontWeight: "400",
                        color: "#333",
                        height: "36px",
                        paddingRight: "36px", // space for dropdown icon
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: "8px 12px",
                      },
                      "& .MuiAutocomplete-endAdornment": {
                        right: "12px",
                        top: "50%",
                        transform: "translateY(-50%)", // vertical center alignment
                      },
                      "& .MuiSvgIcon-root": {
                        color: "#999",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        // label="Select Country"
                        InputLabelProps={{
                          style: {
                            fontSize: "13px",
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        style={{
                          fontSize: "12px",
                          fontWeight: "normal",
                          color: "#212529",
                        }}
                      >
                        {option.label}
                      </li>
                    )}
                  />
                </div>
              </div>
            </>
          </div>
        </div>
      )}
    </>
  );
}

MetaSearchFilter.propTypes = {
  user: PropTypes.object,
  userData: PropTypes.object,
  source_data: PropTypes.object,
  cncData: PropTypes.object,
  brand_data: PropTypes.object,
  updateSourceInputs: PropTypes.func,
};

const mapStateToProps = (state) => ({
  user: state.user,
  cncData: state.cncinputs,
  source_data: state.source,
});

const mapDispatchToProps = {
  updateSourceInputs,
  updateAlert,
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MetaSearchFilter)
);
